import React, { useState, useEffect } from "react"; //eslint-disable-line
import { bindActionCreators } from "redux";
import Select from "react-select"; //eslint-disable-line
import { translate } from "../../utils/i18n";
import { Col, Row, Label, Button } from "reactstrap"; //eslint-disable-line
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { AdvancedFilter, SelectElevation, SelectDateComp } from "./"; //eslint-disable-line
import * as i18nActions from "../../redux/actions/i18nActions";
import * as deviceActions from "../../redux/actions/deviceActions";

function DevicesSelectorComp(props) {
  const [selectedDevices, setSelectedDevices] = useState([]);
  const getSelectedDevicesData = (_selectedDevices) => {
    if (_selectedDevices.length > 0) {
      const currentEpoch = Number.parseInt(Date.now() / 1000);
      props.FetchSelectedDevicesList(props.selectedStartDate, currentEpoch, _selectedDevices, props.ability);
      if (props.isElevationToggleVisible && !props.isCalculatingElevation) {
        props.resetElevationCalculation();
      }
    } else props.SetNoDeviceSelected();
  };

  const handleSelectDeviceOptionsChange = (newSelectedDevicesList) => {
    setSelectedDevices(newSelectedDevicesList);
    getSelectedDevicesData(newSelectedDevicesList);
  };

  const handleElevation = () => {
    if (props.isElevationToggleVisible) props.CalculateElevation(props.isCalculatingElevation, props.selectedDevices, props.data);
  };

  const selectAllDevices = () => {
    if (props.devicesList.length <= 10) handleSelectDeviceOptionsChange(props.devicesList);
  };

  return (
    <React.Fragment>
      <Row className="mt-2 clear-fix">
        {!props.isAdvancedFilterHidden && (
          <Col sm="12" md="12">
            <AdvancedFilter />
          </Col>
        )}
      </Row>
      <Row>
        {props.isElevationToggleVisible && (
          <Col sm="12" md="2" className="mt-1 d-flex flex-column">
            <Label className="invisible mr-2">{`Elevation`}</Label>

            <SelectElevation
              isElevationToggleVisible={props.isElevationToggleVisible}
              onClick={handleElevation}
              elevationState={!props.isCalculatingElevation}
            />
          </Col>
        )}
        <Col
          sm="12"
          md={
            props.isNoDeviceSelected && !props.isElevationToggleVisible
              ? 12
              : props.isNoDeviceSelected
              ? 10
              : props.isElevationToggleVisible
              ? 5
              : 6
          }
          className="mt-1 d-flex flex-column"
        >
          <div className="d-flex">
            <Label className="text-muted mr-2 align-items-center">
              {translate("devicesListLabel")} {props.devicesList.length > 0 && `(${props.devicesList.length})`}
            </Label>
            {props.devicesList.length != 0 && props.devicesList.length <= 10 && (
              <Button color="link" className="pt-0" onClick={selectAllDevices}>
                {translate("selectAll")}
              </Button>
            )}
          </div>
          {
            <Select
              name="DeviceOptions"
              placeholder={"..."}
              value={props.selectedDevices}
              onChange={handleSelectDeviceOptionsChange}
              isClearable={true}
              autoFocus
              options={props.devicesList}
              isMulti={true}
              isDisabled={props.isFetchingDeviceData}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.device}
              className="basic-multi-select w-100"
              classNamePrefix="select"
            />
          }
        </Col>
        {!props.isNoDeviceSelected && (
          <>
            <Col sm="12" md={props.isElevationToggleVisible ? 3 : 4} className="mt-1 d-flex flex-column">
              <Label className="text-muted mr-2">{translate("timePeriodsLabel")}</Label>
              <SelectDateComp display={props.selectedStartDate} />
            </Col>
            <Col sm="12" md="2" className="mt-1 d-flex  flex-column">
              <Label className="invisible mr-2">{`refresh`}</Label>
              <Button
                color="info"
                outline
                onClick={() => getSelectedDevicesData(props.selectedDevices)}
                block
                disabled={props.isFetchingDeviceData}
              >
                <FontAwesomeIcon icon={["fas", "sync-alt"]} className="mr-2" />
                {translate("refresh")}
              </Button>
            </Col>
          </>
        )}
      </Row>
    </React.Fragment>
  );
}
const mapStateToProps = (state) => ({
  devices: state.devicesReducer.devices,
  devicesList: state.devicesReducer.devicesList,
  selectedDevices: state.devicesReducer.selectedDevices,
  data: state.devicesReducer.data,
  selectedStartDate: state.devicesReducer.selectedStartDate,
  selectedEndDate: state.devicesReducer.selectedEndDate,
  isElevationToggleVisible: state.devicesReducer.isElevationToggleVisible,
  isCalculatingElevation: state.devicesReducer.isCalculatingElevation,
  ability: state.usersReducer.ability,
  isNoDeviceSelected: state.devicesReducer.isNoDeviceSelected,
  isFetchingDeviceData: state.devicesReducer.isFetchingDeviceData,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...i18nActions, ...deviceActions }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(DevicesSelectorComp);
